import React, { Component } from "react";
import FormField from "../Components/FormField";
import SelectedBox from "../Components/SelectedBox";
import VendorCard from "../Components/Card";
import WeddingList from "./WeddingList/WeddingList.js";
import Layout from "../Components/Layout";
import "./Builder.css";
// import swal from 'sweetalert';
import {
  vendorTypes,
  defaultPackageOptions,
  traditionalVendorTypes,
  whiteWeddingVendorTypes,
  receptionVendorTypes,
  courtVendorTypes
} from "../constants";

const api = "https://api.lushplans.com/";
// const api = "https://127.0.0.1/";

export const supportedEventTypes = [
  "Traditional",
  "White",
  "Reception",
  "Court"
];

export const builderOptions = {
  currentTab: 0,
  disableNextTabButton: false,
  nextButtonText: "Next",
  forms: [],
  showReviewPage: false,
  showTabs: true,
  showForms: true,
  showErrorMessage: false,
  hideIndexPage: false,
  hideWeddingTypeList: true,
  errorMessage: "",
  activeWeddingType: "white",
  data: {},
  white: {},
  traditional: {},
  court: {},
  reception: {},
  data_status: {},
  wedding: {
    title: "Wedding Info",
    name: "weddingInfo",
    multiple: false,
    length: 1,
    form: [
      {
        name: "weddingType",
        label: "Wedding Types",
        type: "select",
        meta: {
          multiple: true,
          options: supportedEventTypes.map(item => {
            return { value: item, label: `${item} Wedding` };
          })
        }
      }
    ]
  },
  budget: {
    title: "wedding event budget",
    name: "budget",
    multiple: false,
    length: 2,
    form: [
      {
        name: "budget",
        label: "How much is your budget?",
        type: "number"
      }
      // {
      //   name: "currency",
      //   label: "Budget Currency",
      //   type: "select",
      //   meta: {
      //     options: ["Naira", "Dollar"].map(item => {
      //       return { value: item, label: item };
      //     })
      //   }
      // }
    ]
  },
  flexibility: {
    title: "Flexibility",
    name: "flexibility",
    multiple: false,
    length: 1,
    form: [
      {
        name: "flexibility",
        label: "How Flexible is your budget?",
        type: "select",
        multiple: true,
        default: "Somewhat Flexible",
        meta: {
          autocomplete: true,
          options: [
            "Not Flexible",
            "Somewhat Flexible",
            "Completely flexible"
          ].map((item, ind) => {
            return { label: item, value: item };
          })
        }
      }
    ]
  },
  ranking: {
    title: "Ranking",
    name: "ranking",
    multiple: false,
    length: 1,
    form: [
      {
        name: "ranking",
        label: "What is most important to you?",
        type: "select",
        multiple: true,
        default: "Affordability",
        meta: {
          autocomplete: true,
          options: [
            "Affordability",
            "High Class",
            "Popularity",
            "Uniqueness"
          ].map((item, index) => {
            return { label: item, value: item };
          })
        }
      }
    ]
  },
  vendorTypes: {
    title: "Vendor Types",
    name: "types",
    multiple: false,
    length: 1,
    form: [
      {
        name: "types",
        label: "Select Vendor types you want",
        type: "select",
        meta: {
          multiple: true,
          autocomplete: true,
          options: vendorTypes.map((item, index) => {
            return {
              label: item.replace(/\w\S*/g, function(txt) {
                return (
                  txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                );
              }),
              value: item
            };
          })
        }
      }
    ]
  }
};
export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = builderOptions;

    this.weddingTypeVendorMap = {
      traditional: traditionalVendorTypes,
      white: whiteWeddingVendorTypes,
      court: courtVendorTypes,
      reception: receptionVendorTypes
    };
  }
  componentWillMount() {
    var progressInfo = {};
    for (var weddingType in this.weddingTypeVendorMap) {
      progressInfo[weddingType] = 0;
    }
    this.setState({
      progressInfo: progressInfo
    });
  }
  componentDidMount() {
    const { budget, vendorTypes } = this.state;
    const forms = [budget, vendorTypes];
    this.initForms(forms);
  }

  initForms = forms => {
    let data = Object.assign({}, this.state.data);
    for (let item in forms) {
      const formName = forms[item].name;
      data[formName] = data[formName] || "";
    }
    this.setState({
      forms: forms,
      data: data
    });
  };

  onEditForm = (newForm, formName, removedIndex) => {
    let forms = Object.assign(this.state.forms);
    forms.map((item, index) => {
      if (item.name === formName) {
        item.form = newForm;
      }
      return item;
    });

    this.setState({
      forms: forms
    });

    if (removedIndex) {
      let new_data = Object.assign({}, this.state.data);
      for (let item in new_data) {
        if (item === formName) {
          Object.keys(new_data[item]).map((elem, index) => {
            if (elem[elem.length - 1] === removedIndex) {
              delete new_data[item][elem];
            }
            return null;
          });
        }
      }

      this.setState({ data: new_data });
    }
  };

  saveToState = (data, isValid, formName) => {
    const { name, value } = data;

    const inputDataStore =
      name === "weddingType" ? "data" : this.state.activeWeddingType;
    // console.log("INPUT DATA STORE : ", inputDataStore)
    /* eslint-disable  */
    const newFormData = (this.state[inputDataStore][formName || name] = value);
    /* eslint-enable  */
    const newData = Object.assign(this.state[inputDataStore], {
      [formName || name]: newFormData
    });

    this.setState({
      [inputDataStore]: newData,
      data_status: Object.assign(this.state.data_status, {
        [formName]: isValid
      })
    });
  };

  formIsValid = form => {
    return true;
    // TODO Enable later
    // for(let field in form){
    //   const currentField = form[field]
    //   if(this.state.data_status[currentField.name]){
    //     continue
    //   } else{
    //     let name = currentField.name.split(".")
    //     if(name[1]){
    //       name[1] = name[1].toLowerCase()
    //     }
    //     name = name.join(" ")
    //     this.setState({
    //       errorMessage : "Please enter a valid " + name
    //     })
    //     return false
    //   }
    // }
  };
  onBackToBudgetClick = () => {
    var { progressInfo, activeWeddingType } = this.state;
    progressInfo[activeWeddingType] = 0;
    this.setState({
      currentTab: 0,
      showReviewPage: false,
      showTabs: true,
      nextButtonText: "Next",
      progressInfo: progressInfo
    });
  };
  nextTab = () => {
    //Increase % here.
    var progPercentage =
      ((this.state.currentTab + 1) / this.state.forms.length) * 100;

    var { progressInfo } = this.state;
    progressInfo[this.state.activeWeddingType] = progPercentage;
    this.setState({
      progressInfo: progressInfo
    });
    // if(true){
    if (this.formIsValid(this.state.forms[this.state.currentTab].form)) {
      this.setState({
        showErrorMessage: false,
        errorMessage: ""
      });

      if (this.state.currentTab === this.state.forms.length - 1) {
        // var progressInfo = this.state.progressInfo;
        // progressInfo[this.state.activeWeddingType] = 100;
        this.setState({
          showReviewPage: true,
          showTabs: false
        });
      }

      if (this.state.currentTab !== this.state.forms.length - 1) {
        this.setState(
          {
            currentTab: this.state.currentTab + 1
          },
          () => {
            // Check if this is the last tab
            if (this.state.currentTab === this.state.forms.length - 1) {
              this.setState({ nextButtonText: "Preview" });
            }
          }
        );
      }
    } else {
      this.setState({
        showErrorMessage: true
      });
    }
  };

  previousTab = () => {
    var { progressInfo } = this.state;
    progressInfo[this.state.activeWeddingType] -= 25;
    this.setState({
      progressInfo: progressInfo
    });
    if (this.state.currentTab !== 0) {
      this.setState({
        currentTab: this.state.currentTab - 1,
        nextButtonText: "NEXT",
        showReviewPage: false,
        showForms: true,
        showTabs: true
      });
    }
  };

  renderProgressBars = () => {
    return this.state.forms.map((item, index) => {
      return (
        <div
          className={
            "lush-bar col-xs-12 mt-3 " +
            (index <= this.state.currentTab ? "filled-bar" : "")
          }
          key={index}
        />
      );
    });
  };

  renderReviewPage = () => {
    return (
      <div hidden={!this.state.showReviewPage}>
        <h2 className="text-center">
          <strong>{`${this.state.activeWeddingType.toUpperCase()} SUMMARY`}</strong>
        </h2>
        {this.state.forms.map((form, id) => {
          return (
            <div key={id}>
              <div className="center col-xs-12">
                <hr />
                <h3>{form.title.toUpperCase()}</h3>
                <br />
              </div>
              {form.form.map((item, id) => {
                return (
                  <FormField
                    key={id}
                    dataContainer={form.name}
                    formName={form.name}
                    fieldChange={this.saveToState}
                    value={
                      this.state[this.state.activeWeddingType][item.name] ||
                      item.default ||
                      ""
                    }
                    field={item}
                    submitActive={this.state.submit}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  renderErrorMessage = () => {
    return (
      <div
        className="error-container mt-4"
        hidden={!this.state.showErrorMessage}
      >
        {this.state.errorMessage}
      </div>
    );
  };

  parseMultipleForms = form => {
    let result = {
      base: {}
    };

    const isNum = char => {
      return "0123456789".indexOf(char) !== -1;
    };
    for (let field in form) {
      const nameLength = field.length;
      const char = field.slice(nameLength - 1);
      if (isNum(char)) {
        field = field.slice(0, nameLength - 1);
        if (result[char]) {
          result[char] = Object.assign({ [field]: form[field] }, result[char]);
        } else {
          result[char] = {
            [field]: form[field]
          };
        }
      } else {
        result.base = Object.assign({ [field]: form[field] }, result.base);
      }
    }

    if (Object.keys(result).length === 1) {
      return result.base;
    }

    let data = Object.keys(result).map((item, index) => {
      return result[item];
    });

    return data;
  };

  submitForm = () => {
    // let valid = null
    for (let index in this.state.forms) {
      // if(false){
      if (!this.formIsValid(this.state.forms[index].form)) {
        this.setState({
          showErrorMessage: true
        });
        return;
      }
    }
    let data = {};
    for (var key in this.state[this.state.activeWeddingType]) {
      data[key] =
        this.state[this.state.activeWeddingType][key] ||
        defaultPackageOptions[key];
    }

    data.weddingType = this.state.activeWeddingType;
    data.budget = data.budget ? data.budget : 0;
    data.vendors = data.vendors && data.vendors.length > 0 ? data.vendors : [];

    fetch(api + "_package", {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(res => {
        this.setState({
          recommendation: res
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  setVendorOptions = () => {
    let vendorTypes = this.weddingTypeVendorMap[
      this.state.activeWeddingType.toLowerCase()
    ];
    // vendorTypes = Array.from(new Set(vendorTypes))
    const newForms = this.state.forms.map(item => {
      if (item.name === "types") {
        item.form = [
          {
            name: "types",
            label: "Select Vendor types you want",
            type: "select",
            meta: {
              multiple: true,
              autocomplete: true,
              options: vendorTypes.map((item, index) => {
                return {
                  label: item.replace(/\w\S*/g, function(txt) {
                    return (
                      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                    );
                  }),
                  value: item
                };
              })
            }
          }
        ];
      }

      return item;
    });
    this.initForms(newForms);

    const inputDataStore = this.state.activeWeddingType;

    // console.log("INPUT DATA STORE : ", inputDataStore)
    /* eslint-disable  */

    /* eslint-enable  */
    // const newData = Object.assign(this.state[inputDataStore], { types : this.weddingTypeVendorMap[inputDataStore]})
    this.saveToState(
      { value: this.weddingTypeVendorMap[inputDataStore], name: "types" },
      true
    );
    // this.setState({
    //   [inputDataStore] : newData,
    // });
  };

  renderWeddingTypeCards = () => {
    // Check if any wedding type selected
    const weddingTypes = this.state.data.weddingType || [];
    console.log("TYPES : ", weddingTypes);
    return (
      <div className="row mt-2" hidden={this.state.hideWeddingTypeList}>
        {weddingTypes.map(item => {
          return (
            <VendorCard
              title={item}
              text={item}
              onClick={() => {
                // this.setVendorOptions()
                this.setState(
                  {
                    hideIndexPage: true,
                    hideWeddingTypeList: true,
                    showForms: true,
                    activeWeddingType: item.toLowerCase(),
                    showTabs: true
                  },
                  this.setVendorOptions
                );
              }}
            />
          );
        })}
      </div>
    );
  };

  onSelectedBoxClick = (text, name) => {
    let data = this.state.data[name].filter(item => {
      return item !== text;
    });

    this.saveToState({ value: data }, data.length > 0, name);
  };

  renderIndex = () => {
    const weddingForm = this.state.wedding.form;
    const data = this.state.data["weddingType"] || [];
    const extra = (
      <div>
        {data.map(data => {
          return (
            <SelectedBox
              text={data}
              onClick={() => {
                this.onSelectedBoxClick(data, "weddingType");
              }}
            />
          );
        })}
      </div>
    );
    return (
      <div hidden={this.state.hideIndexPage}>
        {extra}
        {weddingForm.map((item, index) => {
          return (
            <FormField
              key={index}
              formName={this.state.formName}
              fieldChange={this.saveToState}
              value={this.state.data[item.name] || item.default || ""}
              field={item}
            />
          );
        })}
        <button
          className="lush-btn mt-2"
          onClick={() => {
            this.setState({
              hideIndexPage: true,
              hideWeddingTypeList: false
            });
          }}
        >
          {" "}
          Proceed{" "}
        </button>
      </div>
    );
  };
  renderForm = () => {
    return (
      <div className="height">
        <div className="mx-auto w-100">
          <div hidden={!this.state.showForms} className="formContainer">
            {this.state.forms.map((form, id) => {
              return (
                <Tab
                  index={id}
                  formName={form.name}
                  formLength={form.length}
                  multiple={form.multiple}
                  key={id}
                  title={`${this.state.activeWeddingType} ${form.title}`}
                  tabForm={form.form}
                  data={this.state[this.state.activeWeddingType]}
                  hidden={id !== this.state.currentTab || !this.state.showTabs}
                  onInput={this.saveToState}
                  onEditForm={this.onEditForm}
                />
              );
            })}

            {this.renderReviewPage()}

            {this.renderErrorMessage()}

            <div className="center" hidden={!this.state.showTabs}>
              <button onClick={this.nextTab} className="mt-4 ml-1 lush-btn">
                <b> {this.state.nextButtonText} </b>
              </button>
            </div>

            <div className="center" hidden={!this.state.showReviewPage}>
              <button
                className="mt-4 lush-btn"
                onClick={this.onBackToBudgetClick}
              >
                <b> Back to start</b>
              </button>
              <button
                onClick={this.submitForm}
                className="mt-4 lush-btn"
                disabled={false}
                hidden={false}
              >
                <b> Generate package </b>
              </button>

              {/* <br />
              <p>
                We are currently working out prizing for our wedding package
                generator. Check back later. For now, see our{" "}
                <a
                  href="https://instagram.com/lushplans"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Instagram
                </a>{" "}
                for inspo
              </p> */}
            </div>
            {this.state.recommendation && (
              <div>
                <hr />
                <h4>{`Spent: ${this.state.recommendation.spent}`}</h4>
                <h4>{`Balance: ${this.state.recommendation.balance}`}</h4>
                {this.state.recommendation.recommended.map((rec, ind) => {
                  return (
                    rec && (
                      <div className="col-xs-12">
                        <hr />
                        <h4>
                          <strong>{`${rec.details.types[0].toUpperCase()}`}</strong>{" "}
                        </h4>
                        {`${rec.cost} was allocated.`}
                        <br />
                        <u>{rec.details.id}</u>
                        {` is the number ${rec.details.typeRank} ${
                          rec.details.types[0]
                        }.   `}
                        <a
                          className="mt-4 lush-btn"
                          href={`https://app.lushplans.com/?ig=${
                            rec.details.id
                          }`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View vendor profile
                        </a>
                      </div>
                    )
                  );
                })}
              </div>
            )}
          </div>
          <br />
        </div>
        <div className="">
          <button
            onClick={this.previousTab}
            hidden={this.state.currentTab === 0}
            className="lush-btn"
          >
            <b> Back </b>
          </button>
        </div>
      </div>
    );
  };

  handleCardClick = clickedType => {
    this.setState(
      {
        activeWeddingType: clickedType,
        showReviewPage: false,
        showTabs: true,
        nextButtonText: "NEXT"
      },
      () => {
        var { progressInfo, activeWeddingType } = this.state;
        var currentTab = progressInfo[activeWeddingType] / 25;
        if (currentTab < 4) {
          this.setState({
            currentTab: currentTab
          });
        } else {
          this.setState({
            showReviewPage: true
          });
        }
      }
    );
  };

  render() {
    const { activeWeddingType } = this.state;
    return (
      <Layout
        leftComponent={
          <WeddingList
            onProgressUpdate={[
              this.state.progressInfo[activeWeddingType],
              activeWeddingType
            ]}
            activeWeddingType={activeWeddingType}
            onCardClick={this.handleCardClick}
          />
        }
        rightComponent={this.renderForm()}
      />
    );

    if (!this.props.isLoggedin()) {
      return <div className="height">{this.props.authPage}</div>;
    }
  }
}

class Tab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: [],
      data: {},
      noOfForms: 1,
      formLength: 0,
      formName: ""
    };
  }

  componentDidMount() {
    const { tabForm, formLength, formName } = this.props;
    this.setState({
      form: tabForm || [],
      formLength: formLength,
      formName
    });
  }

  componentWillReceiveProps(nextProps) {
    const { tabForm, formLength, formName } = this.props;
    this.setState({
      form: tabForm || [],
      formLength: formLength,
      formName
    });
  }

  tabSaveToState = (data, isValid, formName) => {
    formName = formName || this.props.formName;

    const { value, name } = data;

    formName = name || formName;

    const newData = Object.assign(this.state.data, { [formName]: value });

    this.setState({ data: newData });
    this.props.onInput(data, isValid, formName);
  };

  addNewForm = () => {
    this.setState(
      {
        noOfForms: this.state.noOfForms + 1
      },
      () => {
        this.updateForm();
      }
    );
  };

  removeForm = () => {
    if (this.state.noOfForms > 1) {
      this.setState(
        {
          noOfForms: this.state.noOfForms - 1
        },
        () => {
          this.updateForm(true);
        }
      );
    }
  };

  updateForm = removed => {
    let form = [];

    const original_form = Object.assign(this.state.form).slice(
      0,
      this.state.formLength
    );

    for (let i = 0; i < this.state.noOfForms; i++) {
      const index = i === 0 ? "" : i;

      for (let item in original_form) {
        let new_item = Object.assign({}, original_form[item]);

        new_item.name = new_item.name + String(index);

        form.push(new_item);
      }
    }

    this.setState({
      form: form
    });

    const removedIndex = removed ? this.state.noOfForms : undefined;

    this.props.onEditForm(form, this.props.formName, removedIndex);
  };

  onSelectedBoxClick = (text, name) => {
    let data = this.props.data[name].filter(item => {
      return item !== text;
    });

    this.tabSaveToState({ value: data }, data.length > 0, name);
  };

  render() {
    let counter = -1;
    return (
      <div hidden={this.props.hidden}>
        <div>
          <h3 className="mb-3 text-center">
            <strong>{this.props.title.toUpperCase()}</strong>
          </h3>
        </div>
        {this.state.form.map((item, id) => {
          counter += 1;

          const formMeta = item.meta || {};

          let extra = null;
          if (item.type === "select" && formMeta.multiple) {
            const data = this.props.data[item.name] || [];
            extra = (
              <div>
                {data.map(data => {
                  return (
                    <SelectedBox
                      text={data}
                      onClick={() => {
                        this.onSelectedBoxClick(data, item.name);
                      }}
                    />
                  );
                })}
              </div>
            );
          }
          return (
            <div key={id}>
              <hr
                className="mt-5 mb-5"
                hidden={counter % this.state.formLength !== 0 || counter === 0}
              />
              {extra}
              <FormField
                key={id}
                formName={this.state.formName}
                fieldChange={this.tabSaveToState}
                value={this.props.data[item.name] || item.default || ""}
                field={item}
              />
            </div>
          );
        })}

        <button
          className="pull-right lush-btn"
          hidden={this.state.noOfForms <= 1}
          onClick={this.removeForm}
        >
          Cancel
        </button>

        <br />
        <br />

        <button
          hidden={!this.props.multiple}
          onClick={this.addNewForm}
          className="mt-4 lush-btn"
        >
          {"Add new " + this.props.title}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Builder/Builder.js